import { createContext } from "react"

const context = createContext("asphalt")
export const Provider = context.Provider
export const Consumer = context.Consumer
export default context

export const StyleContext = createContext()
export const StyleProvider = StyleContext.Provider
export const StyleConsumer = StyleContext.Consumer

export { sendStyles } from "./sendstyles"
